import { defineMessages } from 'react-intl';

const translations = {
  emptyMessage: {
    id: 'appsList.emptyMessage',
    defaultMessage: 'No apps available',
    description: 'Empty message of the apps list',
  },
  feedback: {
    integrationAlreadyAdded: {
      id: 'appsList.feedback.integrationAlreadyAdded',
      defaultMessage: 'You can only have a single integration for this app',
      description: 'Warning message no duplicate integrations add app action',
    },
  },
};

export default defineMessages(translations);
